import { Input, InputProps } from '~/components';
import { cn } from '~/style';

export type FormNumberInputProps = {
  value: number;
  label?: string;
  placeholder?: string;
  onChange: (value: number) => void;
  min?: InputProps['min'];
  max?: InputProps['max'];
  autoCapitalize?: InputProps['autoCapitalize'];
  autoCorrect?: InputProps['autoCorrect'];
  spellCheck?: InputProps['spellCheck'];
  disabled?: boolean;
  className?: string;
};

export const FormNumberInput = ({
  value,
  label,
  placeholder,
  onChange,
  min,
  max,
  autoCapitalize,
  autoCorrect,
  spellCheck,
  disabled,
  className,
}: FormNumberInputProps) => {
  return (
    <div className="space-y-4">
      {label && (
        <div
          className={cn({
            'text-muted-foreground opacity-50': disabled,
          })}
        >
          {label}
        </div>
      )}

      <Input
        className={className}
        value={value}
        placeholder={placeholder && placeholder}
        onChange={(event) => onChange(Number(event.target.value))}
        type="number"
        min={min}
        max={max}
        step={0.1}
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        spellCheck={spellCheck}
        disabled={disabled}
      />
    </div>
  );
};
